import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFavoritos, toggleFavorito } from "../api";
import "../assets/css/style.css";
import { toast } from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { motion } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Favoritos = () => {
  const { user, authReady } = useAuth();
  const navigate = useNavigate();
  const [comercios, setComercios] = useState([]);
  const [loadingFavoritos, setLoadingFavoritos] = useState(true);
  const showSplash = useDynamicSplash(loadingFavoritos);

  useEffect(() => {
    window.history.replaceState({}, "", "/perfil");
    window.history.pushState({}, "", "/favoritos");
  }, []);

  useEffect(() => {
    if (!authReady || !user?.id) return;

    const cargarFavoritos = async () => {
      setLoadingFavoritos(true);
      document.body.style.overflow = "hidden";
      try {
        const data = await getFavoritos(user.id);
        setComercios(data || []);
      } catch (err) {
        toast.error("Error cargando favoritos.");
        console.error("❌ Error cargando favoritos:", err);
      } finally {
        setLoadingFavoritos(false);
        document.body.style.overflow = "auto";
        window.scrollTo(0, 0);
      }
    };
    cargarFavoritos();
  }, [user, authReady]);

  const handleUnfollow = async (id_comercio) => {
    const result = await toggleFavorito(id_comercio, user.id);
    if (result.success && result.favorito === false) {
      setComercios((prev) => prev.filter((c) => c.id_comercio !== id_comercio));
      toast.dismiss();
      toast.success("Eliminado de favoritos.");
    } else {
      toast.dismiss();
      toast.error("No se pudo eliminar de favoritos.");
    }
  };

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}

      {!showSplash && (
        <motion.div
          initial={{ y: "100%", opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: "100%", opacity: 0 }}
          transition={{ duration: 0.7, ease: "easeInOut" }}
        >
          <div className="app-container">
            <div className="connections-container">
              <div className="back-container">
                <button className="back-btn" onClick={() => navigate("/perfil", { replace: true })}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="48"
                      d="M244 400L100 256l144-144M120 256h292"
                    />
                  </svg>
                </button>
              </div>
              <h2 className="connections-title">Mis favoritos</h2>
            </div>

            {comercios.length > 0 ? (
              <div className="suggestions-container" style={{ marginTop: 10 }}>
                {comercios.map((c) => (
                  <div
                    className="suggestion-item"
                    key={c.id_comercio}
                    onClick={() => navigate(`/comercio/app/${c.id_sucursal}`)}
                    style={{
                      borderBottom: "1px solid #eee",
                      paddingBottom: 6,
                      marginBottom: 5,
                    }}
                  >
                    <img
                      src={c.logo || "/assets/images/default.png"}
                      alt={c.nombre}
                      width="30"
                      height="30"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/assets/images/default.png";
                      }}
                    />
                    <div className="suggestion-info">
                      <h4>
                        {c.nombre}
                        <span className="verified-home">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M10.95 12.7L9.5 11.275Q9.225 11 8.813 11t-.713.3q-.275.275-.275.7t.275.7l2.15 2.15q.3.3.7.3t.7-.3l4.25-4.25q.3-.3.287-.7t-.287-.7q-.3-.3-.712-.312t-.713.287zm-2.8 9.05L6.7 19.3l-2.75-.6q-.375-.075-.6-.387t-.175-.688L3.45 14.8l-1.875-2.15q-.25-.275-.25-.65t.25-.65L3.45 9.2l-.275-2.825q-.05-.375.175-.688t.6-.387l2.75-.6l1.45-2.45q.2-.325.55-.438t.7.038l2.6 1.1l2.6-1.1q.35-.15.7-.038t.55.438L17.3 4.7l2.75.6q.375.075.6.388t.175.687L20.55 9.2l1.875 2.15q.25.275.25.65t-.25.65L20.55 14.8l.275 2.825q.05.375-.175.688t-.6.387l-2.75.6l-1.45 2.45q-.2.325-.55.438t-.7-.038l-2.6-1.1l-2.6 1.1q-.35.15-.7.038t-.55-.438"
                            />
                          </svg>
                        </span>
                      </h4>
                    </div>
                    <button
                      className="follow-btn bg-white"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleUnfollow(c.id_comercio);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#dc3545"
                          fillRule="evenodd"
                          d="M12 3.942a6.35 6.35 0 0 1 4.305-1.692c1.726 0 3.374.71 4.58 1.96a6.7 6.7 0 0 1 1.865 4.652a6.7 6.7 0 0 1-1.865 4.652c-.796.825-1.591 1.67-2.39 2.518c-1.624 1.724-3.265 3.467-4.97 5.108l-.003.004a2.213 2.213 0 0 1-3.113-.069l-7.295-7.561c-2.485-2.577-2.485-6.727 0-9.303A6.33 6.33 0 0 1 12 3.942"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ textAlign: "center", padding: "1rem" }}>
                Aún no tienes comercios favoritos.
              </p>
            )}
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Favoritos;
